import React, {useState, useEffect} from 'react';
import rootCauseIcon from "../../../../../resources/images/root-cause-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import DatePicker from "react-datepicker";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";

export const ChangeIdeaThree = ({
                                    context, setContext, navigateTo, navigateBack, setSpinnerText,
                                    showToaster,
                                    toolTipsEnabled
                                }) => {

    const [toImprove, setToImprove] = useState("");
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [byDate, setByDate] = useState(null);

    useEffect(() => {
        if (context.changeIdeaScreen) {
            if (context.changeIdeaScreen.toImprove) {
                setToImprove(context.changeIdeaScreen.toImprove);
            }

            if (context.changeIdeaScreen.from) {
                setFrom(context.changeIdeaScreen.from);
            }

            if (context.changeIdeaScreen.to) {
                setTo(context.changeIdeaScreen.to);
            }

            if (context.changeIdeaScreen.byDate) {
                setByDate(new Date(context.changeIdeaScreen.byDate));
            }
        }
    }, [context]);

    const handleNextClick = () => {
        setContext((prevState) => ({
            ...prevState,
            changeIdeaScreen: {
                ...prevState.changeIdeaScreen,
                toImprove,
                from,
                to,
                byDate
            }
        }));
        navigateTo("changeIdeaFour");
    }

    const isButtonDisabled = () => {
        return (!toImprove || toImprove === "" || !from || from === "" || !to || to === "" || !byDate);
    }

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={rootCauseIcon} alt="Root Cause Icon" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.rootCauseScreen.name}</p>
                </div>
                <div className="wizard-right-container">
                    <div className={"label-div-tooltip"}>
                        <label className="label">PDSA Aim Statement:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"change3pdsaaimstate123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"PDSA Aim Statement:"}/>}
                    </div>
                    <div className="input-container-left-label">
                        <label>To Improve:</label>
                        <input className="text-input"
                               onChange={({target}) => {
                                   setToImprove(target.value)
                               }}
                               disabled={!context.editMode}
                               defaultValue={toImprove ? toImprove : null}/>
                    </div>
                    <div className="input-container-left-label">
                        <label>From:</label>
                        <input className="text-input"
                               onChange={({target}) => {
                                   const numberOnlyRegExp = /^[0-9]*$/;
                                   if (numberOnlyRegExp.test(target.value)) {
                                       setFrom(target.value)
                                   }
                               }}
                               value={from}
                               disabled={!context.editMode}/>
                    </div>
                    <div className="input-container-left-label">
                        <label>To:</label>
                        <input className="text-input"
                               onChange={({target}) => {
                                   const numberOnlyRegExp = /^[0-9]*$/;
                                   if (numberOnlyRegExp.test(target.value)) {
                                       setTo(target.value)
                                   }
                               }}
                               value={to}
                               disabled={!context.editMode}/>
                    </div>
                    <div className="input-container-left-label">
                        <label>By:</label>
                        <DatePicker selected={byDate}
                                    dateFormat='dd/MM/yyyy'
                                    onChange={(selectedDate) => {
                                        setByDate(selectedDate)
                                    }}
                                    className="text-input"
                                    showPopperArrow={false}
                                    disabled={!context.editMode}
                        />
                    </div>
                    {context.viewMode && context.changeIdeaScreen && context.changeIdeaScreen.externalReference &&
                    <CommentToolTip contextName={"Change Idea"} showToaster={showToaster}
                                    setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.changeIdeaScreen.externalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton disabled={isButtonDisabled()} onClick={handleNextClick}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>
        </div>
    );

}
